import React, { useState } from 'react';
import { Settings, Bell, Lock, Globe, User } from 'lucide-react';
import { UserProfile } from '../../settings/UserProfile';

export function SaasSettings() {
  const [activeTab, setActiveTab] = useState('general');

  const tabs = [
    { id: 'general', label: 'General', icon: Settings },
    { id: 'notifications', label: 'Notifications', icon: Bell },
    { id: 'security', label: 'Security', icon: Lock },
    { id: 'api', label: 'API Access', icon: Globe },
    { id: 'user', label: 'User Profile', icon: User },
  ];

  return (
    <div className="extranet-container">
      <div className="extranet-container-header">
        <div className="flex items-center space-x-2">
          <Settings className="h-6 w-6 text-blue-500" />
          <h2 className="text-xl font-bold text-gray-600">Settings</h2>
        </div>
      </div>

      <div className="extranet-container-body">
        {/* Tabs */}
        <div className="border-b border-gray-300">
          <nav className="-mb-px flex space-x-8">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`
                    flex items-center py-4 px-1 border-b-2 font-medium text-sm
                    ${activeTab === tab.id
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                >
                  <Icon className="h-5 w-5 mr-2" />
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Content */}
        <div className="mt-6">
          {activeTab === 'user' && <UserProfile />}

          {activeTab === 'general' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Language & Region</h3>
                <div className="mt-4 space-y-4">
                  <div>
                    <label className="form-label">Language</label>
                    <select className="form-input">
                      <option>English</option>
                      <option>French</option>
                      <option>German</option>
                    </select>
                  </div>
                  <div>
                    <label className="form-label">Time Zone</label>
                    <select className="form-input">
                      <option>UTC</option>
                      <option>UTC+1</option>
                      <option>UTC+2</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'notifications' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Email Notifications</h3>
                <div className="mt-4 space-y-4">
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label className="font-medium text-gray-700">
                        Integration Updates
                      </label>
                      <p className="text-gray-500">
                        Get notified when a hotel accepts or rejects your integration request
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="flex items-center h-5">
                      <input
                        type="checkbox"
                        className="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label className="font-medium text-gray-700">
                        API Status
                      </label>
                      <p className="text-gray-500">
                        Receive notifications about API health and performance
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'security' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">Security Settings</h3>
                <div className="mt-4 space-y-4">
                  <div>
                    <button className="btn-primary">
                      Change Password
                    </button>
                  </div>
                  <div>
                    <button className="btn-primary">
                      Enable Two-Factor Authentication
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'api' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900">API Configuration</h3>
                <div className="mt-4 space-y-4">
                  <div>
                    <label className="form-label">API Key</label>
                    <div className="mt-1 flex rounded-md shadow-sm">
                      <input
                        type="text"
                        readOnly
                        value="••••••••••••••••"
                        className="form-input flex-1"
                      />
                      <button className="btn-primary ml-3">
                        Regenerate
                      </button>
                    </div>
                  </div>
                  <div>
                    <label className="form-label">Webhook URL</label>
                    <input
                      type="url"
                      className="form-input"
                      placeholder="https://your-domain.com/webhook"
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}